
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M21.785 8.077c.66 0 1.31.175 1.881.505l13.177 7.53a3.77 3.77 0 0 1 1.882 3.255v15.059a3.77 3.77 0 0 1-1.882 3.256l-4.882 2.789a10.65 10.65 0 0 0-8.594-7.563 6.09 6.09 0 1 0-3.644.069 10.66 10.66 0 0 0-8.196 7.448l-4.8-2.743a3.77 3.77 0 0 1-1.883-3.256V19.367a3.76 3.76 0 0 1 1.883-3.256l13.176-7.529a3.77 3.77 0 0 1 1.882-.505"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M40.94 31.529V16.47a3.76 3.76 0 0 0-1.882-3.257L25.882 5.685a3.76 3.76 0 0 0-3.764 0l-13.176 7.53A3.76 3.76 0 0 0 7.06 16.47v15.058a3.76 3.76 0 0 0 1.882 3.256l13.176 7.53a3.77 3.77 0 0 0 3.764 0l13.176-7.53a3.77 3.77 0 0 0 1.882-3.256"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","d":"M23.652 30.327a6.09 6.09 0 1 0 0-12.18 6.09 6.09 0 0 0 0 12.18Z"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","d":"M14.254 37.568a10.142 10.142 0 0 1 19.368-.098"}})])
          )
        }
      }
    